import supabase from "@/lib/supabase";

export async function testSupabaseAuth() {
  console.log("=== Testing Supabase Authentication ===");
  
  try {
    // 1. Get current user
    const { data: { user }, error: userError } = await supabase.auth.getUser();
    console.log("1. Current User:");
    console.log("   - User:", user?.email);
    console.log("   - User ID:", user?.id);
    console.log("   - Error:", userError);
    
    // 2. Get current session
    const { data: { session }, error: sessionError } = await supabase.auth.getSession();
    console.log("\n2. Current Session:");
    console.log("   - Session exists:", !!session);
    console.log("   - Access token:", session?.access_token?.substring(0, 50) + "...");
    console.log("   - Expires at:", session?.expires_at ? new Date(session.expires_at * 1000) : null);
    console.log("   - Error:", sessionError);
    
    // 3. Check if token is expired
    if (session?.expires_at) {
      const expiresAt = new Date(session.expires_at * 1000);
      const now = new Date();
      console.log("\n3. Token Expiry:");
      console.log("   - Expires at:", expiresAt);
      console.log("   - Current time:", now);
      console.log("   - Is expired:", expiresAt < now);
    }
    
    // 4. Try to refresh session
    console.log("\n4. Attempting to refresh session...");
    const { data: refreshData, error: refreshError } = await supabase.auth.refreshSession();
    console.log("   - Refresh successful:", !!refreshData.session);
    console.log("   - New token:", refreshData.session?.access_token?.substring(0, 50) + "...");
    console.log("   - Refresh error:", refreshError);
    
    // 5. Test API call
    console.log("\n5. Testing API call...");
    const testUrl = "/api/health";
    const response = await fetch(testUrl, {
      headers: {
        Authorization: `Bearer ${session?.access_token || refreshData.session?.access_token}`,
      }
    });
    console.log("   - API health check status:", response.status);
    
    return {
      user,
      session: session || refreshData.session,
      isAuthenticated: !!user && !!(session || refreshData.session)
    };
    
  } catch (error) {
    console.error("Error testing auth:", error);
    return {
      user: null,
      session: null,
      isAuthenticated: false,
      error
    };
  }
}

// Make it available globally for testing
(window as any).testSupabaseAuth = testSupabaseAuth;